var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"}],attrs:{"value":_vm.formattedValue,"label":"Time","prepend-icon":_vm.icon,"rules":[_vm.time]},on:{"input":_vm.emit}})}
var staticRenderFns = []

export { render, staticRenderFns }